export interface Toast {
  message: string;
  type: ErrorVariants;
  canDisplay: boolean;
  responseStatus: string;
  dismissText?: string;
}

export enum ErrorVariants {
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}
